export default {"src":"/_next/static/media/ProductPortalLogo.26ddc66c.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};